import React from 'react';
import { useTranslation } from 'react-i18next';

export default function MapSection({ address }) {
  const { t } = useTranslation();
  if (!address || !address.trim()) return null;

  const query = encodeURIComponent(address);
  const embedUrl = `https://maps.google.com/maps?q=${query}&output=embed`;

  return (
    <section className="ri-section ri-map" aria-labelledby="ri-map-heading">
      <h2 id="ri-map-heading" className="ri-section-title">
        <span className="ri-section-icon" aria-hidden="true">🗺️</span>
        {t('restaurant.info.location', 'Location')}
      </h2>
      <div className="ri-map-card">
        <div className="ri-map-embed">
          <iframe
            title={t('restaurant.info.mapEmbed', 'Map showing restaurant location')}
            src={embedUrl}
            width="100%"
            height="300"
            frameBorder="0"
            style={{ border: 0, borderRadius: 'var(--ri-radius-md)' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${query}`}
          target="_blank"
          rel="noopener noreferrer"
          className="ri-map-directions"
        >
          📍 {t('restaurant.info.getDirections')}
        </a>
      </div>
    </section>
  );
}
